import { render, staticRenderFns } from "./NewProductModal.vue?vue&type=template&id=d0d2b148"
import script from "./NewProductModal.vue?vue&type=script&lang=js"
export * from "./NewProductModal.vue?vue&type=script&lang=js"
import style0 from "./NewProductModal.vue?vue&type=style&index=0&id=d0d2b148&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports